import type { FC } from 'react';
import { CLOUD_LICENSING_PAGE_PATH } from 'utils/pageGating/cloudLicensingPageGating';
import { BreakdownSection } from './BreakdownSection';
import { ConstructTypeBreakdownChart } from './ConstructTypeBreakdownChart';
import { NoBreakdownData } from './NoBreakdownData';
import { type OverviewRow, toConstructBreakdown } from './licenseBreakdownData';
import { useChartPalette } from './licenseChartPalette';

export type ConstructBreakdownPanelProps = {
  /** Every overview row; the Cloud Construct category is picked out here. */
  rows: OverviewRow[];
};

export const ConstructBreakdownPanel: FC<ConstructBreakdownPanelProps> = ({
  rows,
}) => {
  const palette = useChartPalette();
  const breakdown = toConstructBreakdown(rows, palette.tier);

  return (
    <BreakdownSection
      title='Construct type breakdown'
      detailPath={`${CLOUD_LICENSING_PAGE_PATH}/cloud-constructs`}
      legend={breakdown.legend}
    >
      {breakdown.bars.length === 0 ? (
        <NoBreakdownData />
      ) : (
        <ConstructTypeBreakdownChart breakdown={breakdown} />
      )}
    </BreakdownSection>
  );
};
